import React from 'react';
import '../../css/inicio.css';
import FacebookIcon from '@material-ui/icons/Facebook';
//imagenes
import Logo from '../../img/logo1.png';
import Demo from '../../img/DemoLogo.png';

export default function Nav() {
    return (
        <nav className="site-header sticky-top py-1">
            <div className="container d-flex flex-column flex-md-row justify-content-between">
                <a className="py-2" href="/" aria-label="Inicio">
                    <img src={Demo} width="100" height="50"/>
                </a>
                {/*
                <a className="py-2 d-none d-md-inline-block" href="#">Tour</a>
                <a className="py-2 d-none d-md-inline-block" href="#">Product</a>
                <a className="py-2 d-none d-md-inline-block" href="#">Features</a>
                <a className="py-2 d-none d-md-inline-block" href="#">Enterprise</a>
                <a className="py-2 d-none d-md-inline-block" href="#">Support</a>
                <a className="py-2 d-none d-md-inline-block" href="#">Pricing</a>
                */}
                <a 
                    className="py-2 d-none d-md-inline-block" 
                    href="#"
                    target="_blank"
                    style={{justifyContent: 'center', alignItems: 'flex-end', marginTop: 20}}
                >
                    <FacebookIcon className="icono"/>
                    Demo Facebook
                </a>
            </div>
        </nav>
    )
}
